import { profile } from '../data/profile';
import { projects } from '../data/projects';
import { Reveal } from '../components/Reveal';
import { SocialLinks } from '../components/SocialLinks';
import './Footer.css';

export function Footer({ onNavigate }) {
  const { linkedin, github, email, resume } = profile.socials;

  return (
    <footer id="footer" className="footer">
      <div className="footer-content">
        <Reveal className="footer-brand">
          <h3 className="footer-title">{profile.name}</h3>
          <p className="footer-desc">{profile.subtitle}</p>
          <SocialLinks className="footer-socials" />
        </Reveal>

        <Reveal delay={2}>
          <h4 className="footer-heading">Connect</h4>
          <div className="footer-links">
            <a href={linkedin} target="_blank" rel="noopener noreferrer" className="footer-link">LinkedIn</a>
            <a href={github} target="_blank" rel="noopener noreferrer" className="footer-link">GitHub</a>
            <a href={`mailto:${email}`} className="footer-link">Email</a>
            <a href={resume} target="_blank" rel="noopener noreferrer" className="footer-link">Résumé</a>
          </div>
        </Reveal>

        <Reveal delay={3}>
          <h4 className="footer-heading">Projects</h4>
          <div className="footer-links">
            {projects.map((p) => (
              <button key={p.id} className="footer-link" onClick={() => onNavigate(p.id)}>
                {p.title}
              </button>
            ))}
          </div>
        </Reveal>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} {profile.name}. Designed &amp; built with care.</p>
      </div>
    </footer>
  );
}
